<template lang="html">
  <section class="app-login w-100 d-flex justify-content-center text-center">
    <form @submit.prevent="onSubmit" class="p-3 align-self-center w-80 text-left" :class="$v.dataForm.$invalid ? '':'was-validated'">
      <div class="form-group d-flex justify-content-center">
        <label for="loginId" class="w-25 align-self-center font-weight-bold">* ID : </label>
        <div class="w-100">
          <input :class="$v.dataForm.loginId.$error ? 'is-invalid': ''" type="email"
                 @blur="$v.dataForm.loginId.$touch()" v-model="dataForm.loginId"
                 class="form-control" id="loginId" required>
          <div class="invalid-feedback">
            <div v-if="!$v.dataForm.loginId.required">ID is required !</div>
            <div v-if="!$v.dataForm.loginId.email">Please enter a valid identification !</div>
          </div>
        </div>
      </div>
      <div class="form-group d-flex justify-content-center">
        <label for="loginPassword" class="w-25 align-self-center font-weight-bold">* PASSWORD : </label>
        <div class="w-100">
          <input :class="$v.dataForm.loginPassword.$error ? 'is-invalid': ''" type="password"
                 @blur="$v.dataForm.loginPassword.$touch()" v-model="dataForm.loginPassword"
                 class="form-control" id="loginPassword" required>
          <div class="invalid-feedback">
            <div v-if="!$v.dataForm.loginPassword.required">Password is required !</div>
            <div v-if="!$v.dataForm.loginPassword.minLength">
              Password must have at least {{$v.dataForm.loginPassword.$params.minLength.min}} characters !
            </div>
          </div>
        </div>
      </div>
      <div class="mt-4 text-center">
        <button :class="$v.dataForm.$invalid ? 'cursor-pointer-disabled':''"
                type="submit" class="btn btn-lg btn-success" :disabled="$v.dataForm.$invalid">
          Submit
        </button>
        <button type="button" class="btn btn-lg btn-danger ml-3" @click="resetForm">
          Reset
        </button>
      </div>
    </form>
  </section>
</template>

<script lang="js">
import {mapActions} from "vuex";
import {FORM_LOGIN_VALIDATIONS} from '../validations/formLogin'
export default {
  name: "Login",
  props: [],
  mounted () {},
  created() {},
  validations: FORM_LOGIN_VALIDATIONS,
  data () {
    return {
      dataForm: {
        loginId: undefined,
        loginPassword: undefined
      }
    }
  },
  methods: {
    ...mapActions([
      'login'
    ]),
    onSubmit () {
      const formData = {
        id: this.dataForm.loginId,
        password: this.dataForm.loginPassword
      };
      this.login(formData)
    },
    resetForm () {
      this.dataForm.loginId = undefined;
      this.dataForm.loginPassword = undefined;
    }
  },
  computed: {}
}
</script>

<style scoped lang="scss">
  section{
    form{
      border: 1px solid var(--primary-color);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue